import fetchUPlus from "../httpFetchUPlus.js";
const liveBaseUrl = "/uplus/publicsvc/v2";
// 获取首页banner列表
export function getBannerList(data) {
  return fetchUPlus.post(`${liveBaseUrl}/getBannerList4Uplus`, {
    banner_type: "6002"
  });
  // return fetchUPlus.post(`${liveBaseUrl}/getBannerList`, data);
}
// 获取banner直播详情
export function getLive4Banner(data) {
  return fetchUPlus.post(`${liveBaseUrl}/getLive4Banner`, data);
}
// 获取首页最新直播
export function getLiveIndexList(data) {
  return fetchUPlus.post(`${liveBaseUrl}/getLiveIndexList`, data);
}
// 获取首页直播列表【搜索直播】
export function queryLiveList2(data) {
  return fetchUPlus.post(`${liveBaseUrl}/queryLiveList2`, data);
}
// 我的观看列表
export function getLiveAttendList(data) {
  return fetchUPlus.post(`${liveBaseUrl}/getLiveAttendList`, data);
}
// 直播分类列表
export function getLiveCategoryForeList(data) {
  return fetchUPlus.post(`${liveBaseUrl}/getLiveCategoryForeList`, data);
}
// 获取直播详情
export function getLiveDetail(data) {
  return fetchUPlus.post(`${liveBaseUrl}/getLiveDetail`, data);
}
// 获取直播小程序码
export function getLiveQrCode(data) {
  return fetchUPlus.post(`${liveBaseUrl}/getLiveQrCode`, data);
}
// 直播相关推荐
export function recommend4Live(data) {
  return fetchUPlus.post(`${liveBaseUrl}/recommend4Live`, data);
}
// 当前直播所在分类（面包屑）
export function getLiveCategoryByLiveId(data) {
  return fetchUPlus.post(`${liveBaseUrl}/getLiveCategoryByLiveId`, data);
}
// 直播讲师列表
export function getTeacherList4Live(data) {
  return fetchUPlus.post(`/uplus/ulsvc/v2/getTeacherList4Live`, data);
}

// 查询oep用户会话令牌
export const getOepVerificationToken = params => {
  return fetchUPlus.get(`/service/so-permission/getOepVerificationToken.json`, {
    params: params
  });
};

// 直播详情polyv
export const livePolyvDetail = params => {
  return fetchUPlus.post(`${liveBaseUrl}/livePcDetail`, params, {
    errorHandler: true
  });
};

// 直播报名
export const liveSignup = params => {
  return fetchUPlus.post(`${liveBaseUrl}/signup`, params, {
    errorHandler: true
  });
};

// 直播详情
export const livepcdetail = params => {
  return fetchUPlus.post(`${liveBaseUrl}/livepcdetail`, params);
};

// 直播埋点
export const livepcAttend = params => {
  return fetchUPlus.post(`${liveBaseUrl}/attend`, params);
};

// 课程详情页的直播推荐
export const liveRecommend = params => {
  return fetchUPlus.post(`${liveBaseUrl}/liveRecommend`, params);
};
//获取推送开关状态
export const getWxPushSwitch = params => {
  return fetchUPlus.post(`${liveBaseUrl}/getWxPushSwitch`, params);
};
//设置推送开关状态
export const setWxPushSwitch = params => {
  return fetchUPlus.post(`${liveBaseUrl}/setWxPushSwitch`, params);
};
//获取用户角色类型
export const getUserRoleFlag = params => {
  return fetchUPlus.post(`${liveBaseUrl}/getUserRoleFlag`, params);
};

//获取公众号绑定状态
export const getWxBindStatus = params => {
  return fetchUPlus.post(`${liveBaseUrl}/getWxBindStatus`, params);
};



// WEBPACK FOOTER //
// ./src/gtn/api/uPlusApi/live.js